export interface AgentState {
  stage: number;
  dimension: number;
  complete: boolean;
  approved: boolean;
  dimensionsCompleted: number[];
}

const TRACKING_TAG_RE =
  /<!-- STAGE:(\d+) DIMENSION:(\d+|none) COMPLETE:(true|false)(?:\s+APPROVED:(true|false))? -->/;

export function parseAgentState(content: string): AgentState | null {
  const match = content.match(TRACKING_TAG_RE);
  if (!match) return null;
  return {
    stage: parseInt(match[1]),
    dimension: match[2] === 'none' ? 0 : parseInt(match[2]),
    complete: match[3] === 'true',
    approved: match[4] === 'true',
    dimensionsCompleted: [],
  };
}

export function getAgentStateFromMessages(
  messages: { role: string; content: string }[],
): AgentState {
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === 'assistant') {
      const state = parseAgentState(messages[i].content);
      if (state) return state;
    }
  }
  return { stage: 1, dimension: 0, complete: false, approved: false, dimensionsCompleted: [] };
}

export function stripTrackingTags(content: string): string {
  return content.replace(/<!--[\s\S]*?-->/g, '').trim();
}
